import { ContextualWarning } from 'common/contextual-warning/contextual-warning.js';
import { IModule } from 'redux-state/layout/types.js';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { Catch } from 'utilities/helpers/functional-error-boundary.js';

/**
 * If you're in a .jsx file you cannot just write <T>, but this works:
 * const foo = <T, >(x: T) => x;
 */

export const componentWithErrorBoundary = <T,>(Component: any) =>
  Catch<T & IModule<IModuleConfig>>((props, error) => {
    if (error) {
      console.warn(`[MODULE ERROR] - ${props.config.name}`);
      if (['development', 'staging'].indexOf(__BUILD_ENV__ ?? '') >= 0) {
        return (
          <ContextualWarning
            maintenance={{
              header: props.config.name,
              text: error.message,
              icon: 'warning-general-red',
              isNotice: true,
              issued: new Date().toISOString(),
            }}
          />
        );
      }
      return null;
    }
    return <Component {...props} />;
  });
